import { comoDataTanksTypes } from "redux/reducers/comoDataTanks/comoDataTanksTypes";
import { api_put, api_delete, api_post, api_get} from "services/api";
import { startRequestComp, stopRequestComp, setSnackbar } from "../search/searchActions";

const {
  SET_COMO_DATA_TANKS_FILTERS,
  COMO_DATA_TANK_SELECTED,
  EDIT_COMO_DATA_TANK_MODE,
  ADD_COMO_DATA_TANK_MODE,
  DELETE_COMO_DATA_TANK_MODE,
  GET_COMO_DATA_TANK,
  CREATE_COMO_DATA_TANK,
  MOD_COMO_DATA_TANK,
  DELETE_COMO_DATA_TANK,
  RESET_COMO_DATA_TANK_SELECTED,
  CLEAR_COMO_DATA_TANKS,
  GET_BRAND_TANK,
  GET_CAPACITY_TANK,
  SET_CONFIG_FILTER_COMO_DATA_TANKS,
  SET_CONFIG_PAGE_COMO_DATA_TANKS,
  SET_CONFIG_PAGE_SIZE_COMO_DATA_TANKS,
  SET_CONFIG_SORTED_COMO_DATA_TANKS,
} = comoDataTanksTypes

export const getAllComoDataTanks = () => {
  const url = `${process.env.REACT_APP_URL}/crm/commodatos-tanks`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingComoDataTanks'))

    await api_get(url).then(resp => {
      dispatch({
        type: GET_COMO_DATA_TANK,
        payload: resp
      })
    }).catch(error => {
      dispatch(setSnackbar(error))
    })
    dispatch(stopRequestComp('loadingComoDataTanks'))
  }
}

export const getComoDataTank = (stationID) => {
  const url = `${process.env.REACT_APP_URL}/crm/commodatos-tanks/by-station/${stationID}`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingComoDataTanks'))
    await api_get(url).then(resp => {
      dispatch({
        type: GET_COMO_DATA_TANK,
        payload: resp
      })
    }).catch(error => {
      dispatch(setSnackbar(error))
      dispatch({
        type: GET_COMO_DATA_TANK,
        payload: []
      })
    })
    dispatch(stopRequestComp('loadingComoDataTanks'))
  }
}

export const comoDataTankSelected = (id) => {
  return {
    type: COMO_DATA_TANK_SELECTED,
    payload: id
  }
}

export const addComoDataTankMode = () => {
  return {
    type: ADD_COMO_DATA_TANK_MODE,
  }
}

export const editComoDataTankMode = () => {
  return {
    type: EDIT_COMO_DATA_TANK_MODE,
  }
}

export const deleteComoDataTankMode = () => {
  return {
    type: DELETE_COMO_DATA_TANK_MODE,
  }
}

export const resetComoDataTankSelected = () => {
  return {
    type: RESET_COMO_DATA_TANK_SELECTED
  }
}
export const createNewComoDataTank = (form, action = null) => {
  const url = `${process.env.REACT_APP_URL}/crm/commodatos-tanks`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingComoDataTanks'))

    await api_post(url, form).then(resp => {
      dispatch({
        type: CREATE_COMO_DATA_TANK,
        payload: {...resp, brandName: form.brandName, idBrand: form.brand}
      })
      dispatch(setSnackbar('Creado con éxito', 'success'))
      action && action()
    }).catch(error => {
      dispatch(setSnackbar(error))
    })
    dispatch(stopRequestComp('loadingComoDataTanks'))
  }
}

export const editComoDataTank = (id, form, action=null) => {
  const url = `${process.env.REACT_APP_URL}/crm/commodatos-tanks/${id}`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingComoDataTanks'))

    await api_put(url, form).then(resp => {
      dispatch({
        type: MOD_COMO_DATA_TANK,
        payload: {...resp, brandName: form.brandName}
      })
      dispatch(setSnackbar('El tanque se ha modificado con éxito', 'success'))
      action && action()
    }).catch(error => {
      dispatch(setSnackbar(error))
    })
    dispatch(stopRequestComp('loadingComoDataTanks'))
  }
}

export const deleteComoDataTank = (id, action= null) => {
  const url = `${process.env.REACT_APP_URL}/crm/commodatos-tanks/${id}`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingComoDataTanks'))

    await api_delete(url).then(resp => {
      dispatch({
        type: DELETE_COMO_DATA_TANK,
        payload: resp.id
      })
      dispatch(setSnackbar('El tanque se ha eliminado con éxito', 'success'))
      action && action()
    }).catch(error => {
      dispatch(setSnackbar(error))
    })
    dispatch(stopRequestComp('loadingComoDataTanks'))
  }
}

export const getBrandTanks = () => {
  const url = `${process.env.REACT_APP_URL}/tanks/brand`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingComoDataTanks'))

    await api_get(url).then(resp => {
      dispatch({
        type: GET_BRAND_TANK,
        payload: resp
      })
    }).catch(error => {
      dispatch(setSnackbar(error))
    })
    dispatch(stopRequestComp('loadingComoDataTanks'))
  }
}

export const getCapacityTanks = (idBrandTank) => {
  const url = `${process.env.REACT_APP_URL}/tanks/capacity/${idBrandTank}`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingComoDataTanksActions'))

    await api_get(url).then(resp => {
      dispatch({
        type: GET_CAPACITY_TANK,
        payload: resp
      })
    }).catch(error => {
      dispatch(setSnackbar(error))
    })
    dispatch(stopRequestComp('loadingComoDataTanksActions'))
  }
}

export const clearComoDataTanks = () => {
  return {
    type: CLEAR_COMO_DATA_TANKS,
  }
}

export const setComoDataTanksFilters = (key = "", data) => {
  return {
    type: SET_COMO_DATA_TANKS_FILTERS,
    payload: { data, key }
  }
}

export const setConfigPageComoDataTanks = (page) => {
  return {
    type: SET_CONFIG_PAGE_COMO_DATA_TANKS,
    payload: page,
  };
}

export const setConfigPageSizeComoDataTanks = (pageSize) => {
  return {
    type: SET_CONFIG_PAGE_SIZE_COMO_DATA_TANKS,
    payload: pageSize,
  };
}

export const setConfigFilterComoDataTanks = (filter) => {
  return {
    type: SET_CONFIG_FILTER_COMO_DATA_TANKS,
    payload: filter,
  };
}

export const setConfigSortedComoDataTanks = (sort) => {
  return {
    type: SET_CONFIG_SORTED_COMO_DATA_TANKS,
    payload: sort,
  };
}